import styled from 'styled-components';

export const Legal = styled.div`
    p {
        max-width: 100%;
        font-size: 13px;
        line-height: 17px;
    }
`;

export const NewsletterSignupWrap = styled.div`
    font-size: 16px;

    div.button-row .btn.btn-secondary[disabled] {
        color: #fff;
    }
    i.icon-checkmark {
        color: green;
    }
    .form-group {
        width: 100%;
        transition: all 350ms ease-in-out;
    }
    .form-group.error {
        input {
            outline: none;
        }
    }
    div.error-msg {
        color: red;
        font-size: 12px;
        line-height: 16px;
        width: 100%;
        margin: 1em auto 8px;
    }

    .privacy-link {
        font-size: 12px;
        a {
            color: #0aaff1;
            text-decoration: none;
            &:hover {
                color: #077aa8;
            }
        }
    }

    li.MuiMenuItem-root {
        font-size: 16px;
    }
    .MuiSelect-iconOutlined {
        font-size: 40px;
    }
`;

export const FieldWrap = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    text-align: left;
`;

export const FormGroup = styled.div`
    position: relative;

    &.error {
        &.custom {
            .validation:not(.custom) {
                display: none;
            }
        }
        .validation {
            display: block;
        }
        .form-control {
            border-color: #ed1c24;
            &:focus {
                border-color: lighten(#ed1c24, 20%);
            }
        }
    }
`;

export const FormInput = styled.input`
    &&& {
        &[type='text'] &:focus ~ .control-label,
        &.filled {
            ${(p) => p.theme.breakpoints.down('xs')} {
                top: 8px !important;
            }
        }
        border-radius: 2px;
        padding: 25px 15px 5px;
        background: none;
        font-size: 1.143em;
        font-family: Brutal_Regular, sans-serif;
        border-color: #aeaeae;
        border-bottom-width: 1px;
        border-right-width: 1px;
        margin: 0 0 20px 0;
        height: auto;
        transition: all 0.2s ease;
        box-shadow: none;
        color: white;
        &:focus {
            border-color: #0aaff1;
        }
        &:focus ~ .control-label,
        &.filled {
            top: 2px;
            bottom: 10px;
            left: 15px;
            font-size: 0.78em;
            opacity: 1;
            ${(p) => p.theme.breakpoints.down('xs')} {
                top: 20px;
                left: 15px;
            }
        }
        &[disabled='disabled'] {
            color: #aeaeae;
            background-color: lighten(#aeaeae, 30%);
        }
    }
`;

export const ControlLabel = styled.label`
    font-size: 1em;
    font-family: Brutal_Light, sans-serif;
    position: absolute;
    pointer-events: none;
    left: 15px;
    top: 18px;
    transition: 0.2s ease all;
    color: #aeaeae;
`;

export const ValidationMsg = styled.span`
    display: none;
    color: #ed1c24;
    padding: 0 0 10px;
    position: absolute;
    top: 0px;
    right: 20px;
    font-size: 0.78em !important;
    ${(p) => p.theme.breakpoints.down('md')} {
        right: 15px;
        font-size: 0.78em !important;
    }
    ${(p) => p.theme.breakpoints.down('sm')} {
        right: 22px;
    }
    &:after {
        content: '';
        display: none;
    }
`;
